var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, useCallback, useEffect, useState } from "react";
import { enviarAgendamento, getConfig, getDoador, getNews, getPages, getStock, getSugestaoAgendamento, obterAgendamentoAnterior, } from "../../apis/api";
import { useNavigate } from "react-router-dom";
import { Home } from "./Home";
import { estoques, formatarData, toSlug } from "../../util/theme";
import { useWebgate } from "@xvia/webgate-connect";
import dayjs from "dayjs";
// Componente funcional HomeContainer
export const HomeContainer = () => {
    const userInfo = useWebgate();
    // Estados para armazenar dados de configuração, estoque, páginas, botões, notícias e data de atualização
    const [config, setConfig] = useState();
    const [estoque, setEstoque] = useState(estoques);
    const [pages, setPages] = useState([]);
    const [botoes, setBotoes] = useState([]);
    const [noticias, setNoticias] = useState([]);
    const [doador, setDoador] = useState();
    const [agendamentoSugestao, setAgendamentoSugestao] = useState();
    const [agendamento, setAgendamento] = useState();
    const [data_atualizacao, setData_atualizacao] = useState();
    const navigate = useNavigate();
    // Função para buscar a configuração
    const fetchConfig = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getConfig();
        setConfig(response);
    }), []);
    // Função para buscar as páginas
    const fetchPages = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getPages();
        setPages(response);
    }), []);
    // Função para buscar as notícias
    const fetchNews = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getNews();
        setNoticias(response);
    }), []);
    // Função para buscar dados do doador
    const fecthDoador = useCallback((cpf) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getDoador(cpf);
        setDoador(response || {});
    }), []);
    // Função para buscar dados do doador
    const fecthAgendamentoAnterior = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield obterAgendamentoAnterior(userInfo.accessToken, "doacao-de-sangue");
        setAgendamento(response.data[0]);
    }), [userInfo]);
    // Função para buscar agendamento
    const fecthSugestaoAgendamento = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!userInfo)
            return;
        const response = yield getSugestaoAgendamento(userInfo.accessToken, dayjs(userInfo.userInfo.dataNascimento).format("YYYY-MM-DD"), userInfo.userInfo.cep.replace("-", ""));
        setAgendamentoSugestao(response);
    }), [userInfo]);
    // Função para buscar agendamento
    const salvarAgendamento = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!userInfo)
            return;
        console.log(userInfo);
        const response = yield enviarAgendamento(userInfo.accessToken, userInfo.userInfo.cpf, agendamentoSugestao.data, agendamentoSugestao.hora, agendamentoSugestao.unidade.id);
        setAgendamento(JSON.parse(response.detail).data);
    }), [userInfo, agendamentoSugestao]);
    // Função para buscar o estoque de sangue
    const fetchStock = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!config)
            return;
        const response = yield getStock();
        const max = config.valor_maximo || 100;
        const getLevel = (qtd) => (qtd * 100) / max;
        // Mapeamento dos tipos de sangue com seus respectivos níveis e quantidades
        const estoques = [
            {
                tipo: "a_negativo",
                label: "A-",
                level: getLevel(response.a_negativo),
                quantidade: response.a_negativo,
            },
            {
                tipo: "a_positivo",
                label: "A+",
                level: getLevel(response.a_positivo),
                quantidade: response.a_positivo,
            },
            {
                tipo: "ab_negativo",
                label: "AB-",
                level: getLevel(response.ab_negativo),
                quantidade: response.ab_negativo,
            },
            {
                tipo: "b_negativo",
                label: "B-",
                level: getLevel(response.b_negativo),
                quantidade: response.b_negativo,
            },
            {
                tipo: "b_positivo",
                label: "B+",
                level: getLevel(response.b_positivo),
                quantidade: response.b_positivo,
            },
            {
                tipo: "ab_positivo",
                label: "AB+",
                level: getLevel(response.ab_positivo),
                quantidade: response.ab_positivo,
            },
            {
                tipo: "o_negativo",
                label: "O-",
                level: getLevel(response.o_negativo),
                quantidade: response.o_negativo,
            },
            {
                tipo: "o_positivo",
                label: "O+",
                level: getLevel(response.o_positivo),
                quantidade: response.o_positivo,
            },
        ];
        setEstoque(estoques);
        setData_atualizacao(formatarData(response.date_updated));
    }), [config]);
    useEffect(() => {
        var _a, _b;
        // Verifica se o usuário está autenticado e possui o token
        if ((_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userInfo) === null || _a === void 0 ? void 0 : _a.preferred_username) {
            fecthDoador((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userInfo) === null || _b === void 0 ? void 0 : _b.preferred_username
            //  userInfo?.accessToken || ""
            );
            fecthSugestaoAgendamento();
            fecthAgendamentoAnterior();
        }
    }, [
        userInfo,
        fecthSugestaoAgendamento,
        fecthDoador,
        fecthAgendamentoAnterior,
    ]);
    useEffect(() => {
        if (doador && !(doador === null || doador === void 0 ? void 0 : doador.doacao)) {
            doador.mensagem = `Olá ${userInfo.userInfo.name}, você ainda não possui doações registradas, estamos com os estóques baixos, achei um horário e um local próximo com base no seu perfil, podemos agendar?`;
            setDoador(doador);
        }
        if ((doador === null || doador === void 0 ? void 0 : doador.doacao) && (doador === null || doador === void 0 ? void 0 : doador.doacao.length) >= 1) {
            doador.mensagem = `Olá ${userInfo.userInfo.name}, parabéns, você já doou sangue ${doador === null || doador === void 0 ? void 0 : doador.doacao.length} vezes, achei um horário e um local próximo com base no seu perfil, podemos agendar?`;
            setDoador(doador);
        }
        if ((doador === null || doador === void 0 ? void 0 : doador.doacao) && agendamento) {
            doador.mensagem = `Olá ${userInfo.userInfo.name}, não se esqueça de sua doação agendada.`;
            setDoador(doador);
        }
    }, [doador, userInfo, agendamento]);
    useEffect(() => {
        if (!agendamento)
            return;
        const doador = {};
        doador.mensagem = `Parabéns!! Sua doacão está confirmada, são se esqueca a data e o horário, ${dayjs(agendamento.agendado).format("DD/MM/YYYY HH:MM")}`;
        doador.doacao = [{}];
        setDoador(doador);
    }, [agendamento]);
    const navegatePage = useCallback((page) => {
        navigate("/" + toSlug(page.Titulo));
    }, [navigate]);
    const navegateNews = useCallback((news) => {
        navigate("/noticia/" + toSlug(news.slug));
    }, [navigate]);
    // useEffect para buscar dados iniciais e configurar botões
    useEffect(() => {
        if (!config)
            fetchConfig();
        fetchStock();
        if (!pages.length)
            fetchPages();
        if (!noticias.length)
            fetchNews();
        if (config && pages.length) {
            setBotoes(pages
                .filter((page) => { var _a; return (_a = config.botoes) === null || _a === void 0 ? void 0 : _a.some((bt) => bt.Paginas_id === page.id); })
                .map((page) => ({
                label: page.Titulo,
                icon: page.Icone,
                subtitle: page.subtitulo,
                onClick: () => navegatePage(page),
            })));
        }
    }, [
        config,
        estoque.length,
        pages,
        noticias.length,
        fetchConfig,
        fetchStock,
        fetchPages,
        fetchNews,
        navegatePage,
    ]);
    // Renderização do componente Home com as propriedades necessárias
    return createElement(Home, {
        config,
        estoque,
        botoes,
        noticias,
        data_atualizacao,
        doador,
        pages,
        navegatePage,
        agendamentoSugestao,
        salvarAgendamento,
        agendamento,
        navegateNews,
    });
};
